const HSERoutes: any = [
    {
        path: 'hse/:projectId(\\d+)?',
        name: 'hse-all',
        component: () => import('@/views/Project/HSE/views/Hse.vue'),
        meta: {
            title: 'project_menu.hse',
            notRequiredAuth: true,
            permission: ['hse.view_hse_board'],
            requireProject: true,
        },
    },
    {
        path: 'hse-public/:projectId(\\d+)?',
        name: 'hse-all-public',
        component: () => import('@/views/Project/HSE/views/HsePublic.vue'),
        meta: {
            title: 'project_menu.hse',
            notRequiredAuth: true,
            permission: ['hse.view_public_hse_board'],
            requireProject: true,
        },
    },

    {
        path: 'hse/:projectId(\\d+)?',
        name: 'hse-tabs',
        component: () => import('@/views/Project/HSE/views/HseTabs.vue'),
        meta: {
            title: 'project_menu.hse',
            notRequiredAuth: true,
            permission: ['hse.view_hse_board'],
            requireProject: true,
        },

        redirect: { name: 'hse-view-documents' },
        children: [
            {
                meta: { title: 'project_menu.hse' },
                path: 'info',
                name: 'hse-view-info',
                component: () => import('@/views/Project/HSE/views/Info/Info.vue'),
            },
            {
                meta: { title: 'project_menu.hse' },
                path: 'contacts',
                name: 'hse-view-contacts',
                component: () => import('@/views/Project/HSE/views/HseContacts.vue'),
            },
            {
                meta: { title: 'project_menu.hse' },
                path: 'documents',
                name: 'hse-view-documents',
                component: () => import('@/views/Project/HSE/views/Documents/Documents.vue'),
            },
        ],
    },

    {
        path: 'hse-public/:projectId(\\d+)?',
        name: 'hse-tabs-public',
        component: () => import('@/views/Project/HSE/views/HseTabs.vue'),
        meta: {
            notRequiredAuth: true,
            permission: ['hse.view_public_hse_board'],
            requireProject: true,
        },
        redirect: { name: 'hse-view-documents' },
        children: [
            {
                path: 'info',
                name: 'hse-view-info-public',
                component: () => import('@/views/Project/HSE/views/InfoPublic/InfoPublic.vue'),
            },
            {
                path: 'contacts',
                name: 'hse-view-contacts-public',
                component: () => import('@/views/Project/HSE/views/HseContacts.vue'),
            },
            {
                path: 'documents',
                name: 'hse-view-documents-public',
                component: () => import('@/views/Project/HSE/views/Documents/Documents.vue'),
            },
        ],
    },
]

export default HSERoutes
